/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Filter/Status/Active
 * @desc Active filter component for status
 */

import { ICONS } from 'labstep-web/constants/icons';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import type React from 'react';
import type { ExperimentWorkflowFilterStatusActiveProps } from './types';

export const ExperimentWorkflowFilterStatusActive: React.FC<
  ExperimentWorkflowFilterStatusActiveProps
> = ({ clearParams, searchParams }) => (
  <>
    {'entity_state_name' in searchParams && (
      <RemoveLabel
        icon={ICONS.experiment_workflow.info.started}
        name={searchParams.entity_state_name as string}
        onRemoveClick={
          clearParams && (() => clearParams(['entity_state_name']))
        }
      />
    )}
  </>
);
